import firebase from "firebase/compat/app";
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

import { LoginContext, UserContext } from '../Context/Context'

import { useContext } from 'react'

import { useHistory} from 'react-router-dom'


import { ShakeIt } from '../App'

let currentUser;




function Firebase(){
    const history = useHistory();
    const {loggedIn, setLoggedIn} = useContext(LoginContext)
    const {user, setUser} = useContext(UserContext)
    currentUser = user;
    
    function initFirebaseAuth(){
        firebase.auth().onAuthStateChanged(AuthStateObserver);
    }

    initFirebaseAuth();
    
    function AuthStateObserver(user){
        if (user) {
            if (history.location.pathname === '/') history.push("/menu")
            setLoggedIn(true)
            setUser(user)
        } else {
            console.log('disconnected')
            history.push("/")
            setLoggedIn(false)
            setUser(null)
        }
    }


    return <div style={{display:"none"}}>

    </div>
}
export default Firebase



const firebaseConfig = {
    apiKey: "AIzaSyDv-QMSAT6ztqtVMpo9-i4QHS83nF3z_Ac",
    authDomain: "run-boys-run.firebaseapp.com",
    projectId: "run-boys-run",
    storageBucket: "run-boys-run.appspot.com",
    messagingSenderId: "23488194960",
    appId: "1:23488194960:web:da27fd00011f5341666b15"
};

firebase.initializeApp(firebaseConfig);




export function SignOut(){
    firebase.auth().signOut()
}

export function GoogleProvider(){
    return new firebase.auth.GoogleAuthProvider();
}

export function FacebookProvider(){
    return new firebase.auth.FacebookAuthProvider();
}

export function TwitterProvider(){
    return new firebase.auth.TwitterAuthProvider();
}

export function SignUpEmailAndPassword(email, password){
    firebase.auth().createUserWithEmailAndPassword(email, password)
        .then((userCredential) => {
            // Signed in 
            // ...
        })
        .catch((error) => {
            const errorCode = error.code;
            // const errorMessage = error.message;
            // ..

            switch (errorCode){
                case 'auth/invalid-email':
                    console.log("This is not an email you naughty naughty")
                    ShakeIt('signUp')
                    break;
                case 'auth/email-already-in-use':
                    console.log("email does not exists")
                    ShakeIt('signUp')
                    break;
                case 'auth/weak-password':
                    console.log("password must have more than 6 characters")
                    ShakeIt('signUp')
                    break;
                default:
                    break;                
            }
        });
        
}

export function SignInEmailAndPassword(email, password){
    firebase.auth().signInWithEmailAndPassword(email, password)
        .then((userCredential) => {
            // Signed in 
            
            // ...
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            // ..

            

            console.log(errorCode, ": ", errorMessage)
                switch (errorCode){
                    case 'auth/invalid-email':
                        console.log("This is not an email you naughty naughty")
                        ShakeIt('login')
                        break;
                    case 'auth/user-not-found':
                        console.log("email does not exists")
                        ShakeIt('login')
                        break;
                    case 'auth/wrong-password':
                        console.log("wrong password")
                        ShakeIt('login')
                        break;
                    case 'auth/too-many-requests':
                        console.log("You failed too many times, try again later")
                        ShakeIt('login')
                        break;
                    default:
                        break;                
                }
            }
        )
}

//SIGN IN CODE WORKS
//PLACE CODE IN BUTTON
export function connect(Provider){

    
    // var provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(Provider)
    .then(res => {
        console.log(res.user)
        CreateUser(res.user)
        return firebase.auth().getRedirectResult();
    }).then((result) => {
        /** @type {firebase.auth.OAuthCredential} */
        // var credential = result.credential;

        // This gives you a Google Access Token.
        // You can use it to access the Google API.
        // var token = credential.accessToken;
        // The signed-in user info.
        // var user = result.user;
    }).catch((error) => {
        // Handle Errors here.
        // var errorCode = error.code;
        // var errorMessage = error.message;
    });
}


function CreateUser(user){
    console.log('about to create')
    let userCollections = firebase.firestore().collection('users');

    userCollections.doc(user.uid).set({
        uid: user.uid,
        displayName: user.displayName,
        email: user.email,
        emailVerified: user.emailVerified,
        photoURL: user.photoURL,
        highScore: 0
    }, {
        merge: true
    }).then(res => {
            console.log('doc' + user.uid + ' created')
            console.log(user)
            console.log(res)
        }, err => console.log(err))
}

export function GetHighScore(){
    return firebase.firestore().collection('users').doc(currentUser.uid).get().then(res =>{
    var user = res.data()
        return user.highScore
    }).then(res => {
        return res
    })
}

export function SetHighScore(highscore){
    GetHighScore().then(res => {
        if (highscore > res){
            firebase.firestore().collection('users').doc(currentUser.uid).update({highScore: highscore})
        }
    })
}




export function createRun(){
    return GetHighScore().then(res => {
        let runDocument = firebase.firestore().collection('runs');
        let doc = {
            id: Math.floor(Math.random() * 0xFFFFFF).toString(16),
            player: firebase.auth().currentUser.displayName,
            photoURL: firebase.auth().currentUser.photoURL, 
            highScore: res,
            players: 1 
        } 
        
        runDocument.add(doc).catch(function(error) {
            console.error('Error writing new message to database', error);
        })
    
        return doc;
    })
}



export function getRuns(){
    var runs = []
    return firebase.firestore().collection('runs')
    .get().then(querySnapshot => {
        querySnapshot.forEach(docSnapshot => {
            var data = docSnapshot.data();
            runs.push({id: data.id, player: data.player, players: data.players})
        })

    }).then(() => {
        return runs
    })
}

export function getRunById(id){
    var run
    return firebase.firestore().collection('runs').where('id', '==', id)
        .get().then(querySnapShot => {
            querySnapShot.forEach(docSnapshot => {
                run = docSnapshot.data();
            })
        }).then(() => {
            return  run
        })
}

export function DeleteRun(id){
    var toDelete = firebase.firestore().collection('runs').where('id', "==", id);
    toDelete.get().then((querySnapShot) => {
        querySnapShot.forEach((doc) => {
            doc.ref.delete();
        })
    })
}

export function RemovePlayerFromRun(id){
    let doc = firebase.firestore().collection('runs').where('id', '==', id);
    doc.get().then((querySnapShot) => {
        querySnapShot.forEach((doc) => {
            var data = doc.data();
            doc.ref.update({
                players: data.players - 1
            });
        })
    })
}

export function AddPlayerToRun(id){
    let doc = firebase.firestore().collection('runs').where('id', '==', id);
    doc.get().then((querySnapShot) => {
        querySnapShot.forEach((doc) => {
            var data = doc.data();
            doc.ref.update({
                players: data.players + 1
            });
        })
    })
}

export function getLeaderBoard(){
    var Leaderboard = []
    return firebase.firestore().collection('users').orderBy('highScore', 'desc')
    .get().then(querySnapshot => {
        querySnapshot.forEach(docSnapshot => {
            var data = docSnapshot.data();
            Leaderboard.push({displayName: data.displayName, highScore: data.highScore})
        })

    }).then(() => {
        return Leaderboard
    })
}

